<template>
  <el-form-item>
    <el-date-picker
      v-model="dataObj"
      :type="type"
      :placeholder="placeholder"
      size="small"
      @change="change"
    />
  </el-form-item>
</template>

<script>
import Util from "../../utils";

export default {
  props: ["value", "field", "type", "placeholder"],
  data() {
    return {
      dataObj: "",
    };
  },
  methods: {
    change() {
      if (this.dataObj === "" || this.dataObj == null) {
        this.value[this.field] = null;
        return;
      }
      if (this.type === "month") {
        this.value[this.field] = Util.formatDateYM(this.dataObj);
      }
      if (this.type === "date") {
        this.value[this.field] = Util.formatDate(this.dataObj);
      }
    },
  },
};
</script>